window.PageLayersManager = function(scope, rootScope, leaseEditorService, q) {
  let $scope = scope;
  let $rootScope = rootScope;
  let LeaseEditorService = leaseEditorService;
  let $q = q;

  this.addPageBreak = () => {
    let newParagraph = $rootScope.createParagraph();
    let el = getNewPageBreakElement();
    newParagraph.parentElement.insertBefore(el, newParagraph);

    const contentEditable = el.closest("[contenteditable]");
    contentEditable.dispatchEvent(new Event("change"));

    window.track.event(
      new InsertPageBreakEvent({
        context: $rootScope.getContext()
      })
    );
  };

  this.deletePageBreak = (event, element) => {
    const pageBreakWrapper = element || event.target.closest('.page-break-wrapper');
    const pageBreak = pageBreakWrapper.querySelector('br');
    const contentEditable = pageBreakWrapper.closest("[contenteditable]");

    if (!pageBreak.classList.contains("new-page-break")) {
      if (!$scope.lease.layers) {
        $scope.lease.layers = [];
      }

      let layers = [];
      if ($scope.lease.layers) {
        layers = [...$scope.lease.layers];
      } else {
        layers = [];
      }

      let redo = function(scope) {
        return function() {
          $scope.startSaving();
          $scope.safeApply();
          var deferred = $q.defer();
          const pid = pageBreak.getAttribute("pid");
          $scope.lease.layers.push({
            type: "page-break",
            deleted: true,
            id: pid
          });
          $scope.update();
          pageBreak.classList.add("deleted-page-break");
          if (
            pageBreak.nextElementSibling &&
            pageBreak.nextElementSibling.tagName === "PAGE-BREAK"
          ) {
            pageBreak.nextElementSibling.classList.add("lp-hide");
          }
          deferred.resolve();
          $scope.endSaving();
          $scope.safeApply();
          return deferred.promise;
        };
      };

      let undo = function(scope, pageBreak, layers) {
        return function() {
          $scope.startSaving();
          $scope.safeApply();
          var deferred = $q.defer();
          $scope.lease.layers = layers;
          $scope.update();
          pageBreak.classList.remove("deleted-page-break");
          if (
            pageBreak.nextElementSibling &&
            pageBreak.nextElementSibling.tagName === "PAGE-BREAK"
          ) {
            pageBreak.nextElementSibling.classList.remove("lp-hide");
          }
          deferred.resolve();
          $scope.endSaving();
          $scope.safeApply();
          return deferred.promise;
        };
      };

      window.track.event(
        new DeletePreDefinedPageBreakEvent({
          context: $rootScope.getContext()
        })
      );

      $scope.addToHistory({
        id: "remove page break",
        desc: "remove page break from org SML",
        redo: redo(scope),
        undo: undo(scope, pageBreak, layers)
      });
    } else {
      let pageBreakTag = pageBreak.nextElementSibling;
      if (pageBreakTag && pageBreakTag.tagName === "PAGE-BREAK") {
        pageBreakTag.remove(); // remove page-break tag
      }
      pageBreakWrapper.remove(); // remove the wrapper and its contents
      contentEditable.dispatchEvent(new Event("change"));

      window.track.event(
        new DeleteNewlyAddedPageBreakEvent({
          context: $rootScope.getContext()
        })
      );

      if (pageBreakWrapper.closest(".list-item-paragraph")) {
        const contenteditable = pageBreakWrapper.closest("[contenteditable]");

        if (contenteditable && LeaseEditorService.isEmpty(contenteditable)) {
          var insertedListItemId = LeaseEditorService.closestNewListItemId(
            pageBreak
          );

          scopeVar.listsDeleteListItem(false, false, insertedListItemId);

          window.track.event(
            new DeleteNewlyAddedPageBreakEvent({
              context: $rootScope.getContext()
            })
          );
        }
      }
    }
  };

  this.updatePageBreaks = () => {
    if (!$scope.lease.layers) {
      return;
    }
    for (let index = 0; index < $scope.lease.layers.length; ++index) {
      let layer = $scope.lease.layers[index];
      if (layer.type === "page-break") {
        if (layer.deleted) {
          let pbNode = document.querySelector(`br[pid="${layer.id}"]`);

          if (pbNode) {
            pbNode.classList.add("deleted-page-break");
          }
        }
      }
    }
  };

  this.getNextLayerId = () => {
    if (!$scope.lease.layers || $scope.lease.layers.length == 0) {
      return 3000000;
    }

    let max = 0;
    for (let index = 0; index < $scope.lease.layers.length; ++index) {
      let id = parseInt($scope.lease.layers[index].id);
      if (id > max) {
        max = id;
      }
    }
    return max + 100;
  };

  this.setupPageBreak = el => {
    this.addRemoveBtnToPageBreak(el);
  }

  this.setupSectionBreak = el => {
    if (el.getAttribute("pid") || el.classList.contains("new-section-break")) {
      // If the element is already a wrapper, use it
      let wrapper = el.classList.contains('section-break-wrapper') ? el : el.parentElement;
      
      // If there's no wrapper, create one
      if (!wrapper || !wrapper.classList.contains('section-break-wrapper')) {
        wrapper = document.createElement("div");
        wrapper.classList.add("section-break-wrapper");
        
        // If el is a br, move both the br and its following element into the wrapper
        if (el.tagName === 'BR') {
          // Get reference to the following element before moving the br
          const nextElement = el.nextElementSibling;
          const isSectionBreak = nextElement && nextElement.tagName === 'SECTION-BREAK';
          
          el.parentNode.insertBefore(wrapper, el);
          wrapper.appendChild(el);
          
          // Move the following element if it exists
          if (isSectionBreak) {
            wrapper.appendChild(nextElement);
          }
        } else {
          // If el is not a br, it should be the wrapper itself
          wrapper.appendChild(el);
        }
      }
    }
  }

  this.addRemoveBtnToPageBreak = el => {
    if (el.getAttribute("pid") || el.classList.contains("new-page-break")) {
      // If the element is already a wrapper, use it
      let wrapper = el.classList.contains('page-break-wrapper') ? el : el.parentElement;
      
      // If there's no wrapper, create one
      if (!wrapper || !wrapper.classList.contains('page-break-wrapper')) {
        wrapper = document.createElement("div");
        wrapper.classList.add("page-break-wrapper");
        
        // If el is a br, move both the br and its following element into the wrapper
        if (el.tagName === 'BR') {
          // Get reference to the following element before moving the br
          const nextElement = el.nextElementSibling;
          const isPageBreak = nextElement && nextElement.tagName === 'PAGE-BREAK';
          
          el.parentNode.insertBefore(wrapper, el);
          wrapper.appendChild(el);
          
          // Move the following element if it exists
          if (isPageBreak) {
            wrapper.appendChild(nextElement);
          }
        } else {
          // If el is not a br, it should be the wrapper itself
          wrapper.appendChild(el);
        }
      }

      // Add the remove button if it doesn't exist
      const breakElement = wrapper.querySelector('page-break');
      if (breakElement && !breakElement.querySelector('.page-break__remove')) {
        let removeEl = document.createElement("div");
        removeEl.classList.add("page-break__remove", "remove-on-download");
        removeEl.addEventListener("click", pageLayersManager.deletePageBreak, [this]);
        breakElement.appendChild(removeEl);
      }
    }
  };

  function getNewPageBreakElement() {
    let wrapper = document.createElement("div");
    wrapper.classList.add("page-break-wrapper");
    wrapper.style.position = "relative";
    
    let el = document.createElement("br");
    el.setAttribute(
      "style",
      "page-break-before:always; clear:both;"
    );
    el.setAttribute("class", "new-page-break");

    // Create and append the page-break element before moving anything
    let pageBreak = document.createElement("page-break");
    
    wrapper.appendChild(el);
    wrapper.appendChild(pageBreak);

    if (!window.isDownload) {
      let removeEl = document.createElement("div");
      removeEl.classList.add("page-break__remove", "remove-on-download");
      removeEl.addEventListener("click", pageLayersManager.deletePageBreak, [this]);
      pageBreak.appendChild(removeEl);
    }
    
    return wrapper;
  }

  this.addOutlineAndListItem = (outline, listItem, isNewListItem) => {
    let currentUndoIndex = $scope.histIndex;
    const outlineId = this.addOutline(outline);
    let itemObject = {
      level: listItem,
      outline: outline,
      headerFreeText: $scope.getNextFreeTextValue(),
      bodyFreeText: $scope.getNextFreeTextValue(),
      afterFreeText: outlineId,
      isNewListItem: isNewListItem,
      fromUI: false
    };
    $scope.listsNewListItem(null, itemObject, null, null, true);
    $scope.histRegisterBatch(
      $scope.histStack.length - 1,
      $scope.histIndex - currentUndoIndex
    );

    window.track.event(
      new InsertOutlineAndListItemEvent({
        level: listItem,
        outline: outline,
        context: $rootScope.getContext()
      })
    );
  };

  this.createOutlineObject = (anchor, outline, newOutlineId, index) => {
    newOutlineId = newOutlineId ? newOutlineId : this.getNextLayerId();

    return {
      type: "outline",
      anchor: anchor,
      id: newOutlineId,
      index: index,
      data: { outline: outline }
    };
  };

  this.addOutline = outline => {
    if (!$scope.lease.layers) {
      $scope.lease.layers = [];
    }
    let currentLayers = [...$scope.lease.layers];
    let newOutlineId;
    let topAnchor;
    let index = 0;

    let outlines = Object.keys(listItemsManager.listLevelsMap);
    if (outlines.indexOf(outline) !== -1) {
      let editedNode = $scope.currentlyEditedNode;
      if (editedNode) {
        topAnchor = editedNode.getTopAnchor();
        newOutlineId = this.getNextLayerId();
        index = topAnchor.getNodeOccurrenceIndexByAttribute("pid");
      }
    }

    let redo = function(outline, newOutlineId, topAnchor, $scope) {
      return function() {
        $scope.startSaving();
        $scope.safeApply();
        var deferred = $q.defer();
        addOutlineToDom(outline, newOutlineId, topAnchor);

        $scope.lease.layers.push(
          pageLayersManager.createOutlineObject(
            topAnchor.getAttribute("pid"),
            outline,
            newOutlineId,
            index
          )
        );
        $scope.update();
        $scope.endSaving();
        $scope.safeApply();
        deferred.resolve();
        return deferred.promise;
      };
    };

    let undo = function(currentLayers, newOutlineId, $scope) {
      return function() {
        $scope.startSaving();
        $scope.safeApply();
        var deferred = $q.defer();
        $scope.lease.layers = currentLayers;
        let outlineElement = document.querySelector(
          'outline[pid="' + newOutlineId + '"]'
        );
        if (outlineElement) {
          outlineElement.remove();
        }
        outlineElement = document.querySelector(
          'outline-end[pid="' + newOutlineId + '"]'
        );
        if (outlineElement) {
          outlineElement.remove();
        }
        $scope.update();
        $scope.endSaving();
        $scope.safeApply();
        deferred.resolve();
        return deferred.promise;
      };
    };

    if (topAnchor && newOutlineId && outline) {
      scopeVar.addToHistory({
        id: "insert outline",
        desc: "add new outline with id : " + newOutlineId,
        redo: redo(outline, newOutlineId, topAnchor, $scope, index),
        undo: undo(currentLayers, newOutlineId, $scope)
      });
    }

    return newOutlineId;
  };

  this.createOutlineElement = (outlineName, id) => {
    const template = document.createElement("dummy");
    let outlineDom = document.createElement("outline");
    let outlineEndDom = document.createElement("outline-end");
    outlineDom.setAttribute("name", outlineName);
    outlineDom.setAttribute("pid", id);
    outlineEndDom.setAttribute("name", outlineName);
    outlineEndDom.setAttribute("pid", id);
    template.appendChild(outlineDom);
    template.appendChild(outlineEndDom);
    return template;
  };

  function addOutlineToDom(outlineName, id, topAnchor) {
    if(!topAnchor){
      return;
    }
    let template = this.createOutlineElement(outlineName, id);
    while (template.children.length !== 0) {
      topAnchor.parentElement.insertBefore(
        template.children[template.children.length - 1],
        topAnchor.nextElementSibling
      );
    }

    listItemsManager.addSectionEndForOutlineEnd();
  }

  addOutlineToDom = addOutlineToDom.bind(this);


  

  this.getByAnchorId = (id)=>{
    if (!$scope.lease.layers || $scope.lease.layers.length < 1) {
      return [];
    }
    return lease.layers.filter(item => item.anchor == id);
  }

  this.updateOutlineById = id => {
    if (!$scope.lease.layers || $scope.lease.layers.length < 1) {
      return;
    }

    const layerData = lease.layers.filter(item => item.id === id);
    const  layer = layerData.length == 1 ? layerData[0] : null;

    if(layer){
      let elementIndex = layer.index ? layer.index : 0;
      if (layer.type === "outline") {
        let anchor = document.querySelectorWithInstance(
          `[pid="${layer.anchor}"]`
        );
        let id = layer.id;
        addOutlineToDom(layer.data.outline, id, anchor);
      }
    }
  };

  $scope.addPageBreak = this.addPageBreak;
  $scope.addOutlineAndListItem = this.addOutlineAndListItem;
};
